/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_ZO_90_79 as Componente_ZO_90_79,
  rec_Componente_ck_99_107 as Componente_ck_99_107,
  rec_Componente_dk_100_107 as Componente_dk_100_107,
  rec_Componente_ek_101_107 as Componente_ek_101_107,
  rec_Componente_ik_105_107 as Componente_ik_105_107,
  rec_Componente_lk_108_107 as Componente_lk_108_107,
  rec_Componente_nk_110_107 as Componente_nk_110_107,
  rec_Componente_ok_111_107 as Componente_ok_111_107,
  rec_EquipoUnidad as EquipoUnidad,
  rec_EstadoError as EstadoError,
  rec_EstrategiasUnidad as EstrategiasUnidad,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fo as Fo,
  rec_FormularioUnidad as FormularioUnidad,
  rec_HO as HO,
  rec_Ii as Ii,
  rec_JSXRuntime as JSXRuntime,
  rec_NO as NO,
  rec_NuevoProyecto as NuevoProyecto,
  rec_React as React,
  rec_Sn as Sn,
  rec_TareasUnidad as TareasUnidad,
  rec_Ti as Ti,
  rec_Ux as Ux,
  rec_api as api,
  rec_esAdministrador as esAdministrador,
  rec_puedeAccion as puedeAccion,
  rec_oi as oi,
} from "../../runtime/index.jsx";
export function DetalleUnidad({ id: e }) {
  // Administrar subunidades: crear, editar o eliminar en esta unidad (permisos por acción).
  let t = esAdministrador() || [`planner.unidad.crear_sub`, `planner.unidad.editar`, `planner.unidad.eliminar`].some((c) => puedeAccion(c, e)),
    { confirmar: n } = Fo(),
    [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)([]),
    [s, c] = (0, React.useState)(null),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)([]),
    [m, h] = (0, React.useState)([]),
    [g, _] = (0, React.useState)(!0),
    [v, y] = (0, React.useState)(``),
    [b, x] = (0, React.useState)(null),
    [S, C] = (0, React.useState)(!1),
    [w, T] = (0, React.useState)(`trabajo`),
    [E, D] = (0, React.useState)(!1),
    O = (0, React.useCallback)(async () => {
      (_(!0), y(``), u(``));
      try {
        let [t, n, r, a] = await Promise.all([
          api(`/unidades/${e}`),
          api(`/unidades?padre=${e}`),
          api(`/grupos`),
          api(`/unidades?todas=true`),
        ]);
        (i(t), o(n), p(r), h(a));
        try {
          c(await api(`/unidades/${e}/resumen`));
        } catch (e) {
          (c(null), u(e.message));
        }
      } catch (e) {
        y(e.message);
      } finally {
        _(!1);
      }
    }, [e]);
  (0, React.useEffect)(() => {
    O();
  }, [O]);
  let k = (0, React.useCallback)(async () => {
      try {
        c(await api(`/unidades/${e}/resumen`));
      } catch {}
    }, [e]),
    [A, j] = (0, React.useState)(() => Ux());
  (0, React.useEffect)(() => {
    let e = !0;
    return (
      NO().then(() => {
        e && j(Ux());
      }),
      () => {
        e = !1;
      }
    );
  }, []);
  async function M(e) {
    if (
      await n({
        titulo: `Eliminar "${e.nombre}"`,
        mensaje: `Se borra la unidad del organigrama. No se puede deshacer.`,
        confirmarTexto: `Eliminar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/unidades/${e.id}`, {
          method: `DELETE`,
        }),
          O());
      } catch (e) {
        y(e.message);
      }
  }
  let N = (0, React.useMemo)(() => {
    if (!r) return [];
    let e = A.find((e) => e.codigo === r.tipo);
    return e ? A.filter((t) => t.orden > e.orden) : [];
  }, [r, A]);
  return (
    <EstructuraPrincipal
      title={`Organización`}
      children={[
        <div
          className={`flex flex-col gap-4`}
          children={[
            <Componente_ik_105_107 unidad={r} />,
            <EstadoError mensaje={v} onReintentar={O} />,
            g ? (
              <Componente_dk_100_107 />
            ) : r ? (
              <JSXRuntime.Fragment
                children={[
                  <Componente_ok_111_107
                    unidad={r}
                    resumen={s}
                    resumenError={l}
                  />,
                  <Componente_ck_99_107
                    actual={w}
                    onCambiar={T}
                    items={[
                      {
                        id: `trabajo`,
                        label: `Trabajo`,
                      },
                      {
                        id: `equipo`,
                        label: `Equipo`,
                      },
                      {
                        id: `reuniones`,
                        label: `Reuniones`,
                      },
                    ]}
                  />,
                  w === `trabajo` && (
                    <div
                      className={`animar-entrada flex flex-col gap-4`}
                      children={[
                        !l && (
                          <EstrategiasUnidad
                            unidadId={e}
                            proyectos={s?.proyectos ?? []}
                            onCambio={k}
                          />
                        ),
                        <section
                          className={`flex flex-col gap-2`}
                          children={[
                            <div
                              className={`flex items-center justify-between gap-2`}
                              children={[
                                <p
                                  className={`text-sm font-medium text-(--text-h)`}
                                  children={`Proyectos`}
                                />,
                                puedeAccion(`planner.proyectos.crear`, e) && (
                                <button
                                  type={`button`}
                                  onClick={() => C(!0)}
                                  className={HO}
                                  children={[
                                    <Ti
                                      className={`mr-1 inline h-3.5 w-3.5`}
                                    />,
                                    ` Nuevo proyecto`,
                                  ]}
                                />),
                              ]}
                            />,
                            s?.proyectos?.length > 0 ? (
                              <Componente_nk_110_107 proyectos={s.proyectos} />
                            ) : (
                              <Componente_lk_108_107
                                children={`Todavía no hay proyectos acá. Creá el primero cuando arranque uno.`}
                              />
                            ),
                          ]}
                        />,
                        !l && (
                          <TareasUnidad unidadId={e} unidadNombre={r.nombre} />
                        ),
                      ]}
                    />
                  ),
                  w === `equipo` && (
                    <div
                      className={`animar-entrada flex flex-col gap-4`}
                      children={[
                        !l && <EquipoUnidad unidadId={e} />,
                        <section
                          className={`flex flex-col gap-2`}
                          children={[
                            <div
                              className={`flex flex-wrap items-center justify-between gap-2`}
                              children={[
                                <p
                                  className={`text-sm font-medium text-(--text-h)`}
                                  children={`Equipos que dependen de acá`}
                                />,
                                t && E && N.length > 0 && (
                                  <button
                                    type={`button`}
                                    onClick={() =>
                                      x({
                                        padreId: r?.id ?? null,
                                        niveles: N,
                                      })
                                    }
                                    className={HO}
                                    children={[
                                      <Ti
                                        className={`mr-1 inline h-3.5 w-3.5`}
                                      />,
                                      ` Agregar`,
                                    ]}
                                  />
                                ),
                              ]}
                            />,
                            a.length > 0 ? (
                              <Componente_ek_101_107
                                hijos={a}
                                totales={s?.hijos}
                                administrando={t && E}
                                onEditar={(e) =>
                                  x({
                                    editar: e,
                                  })
                                }
                                onEliminar={M}
                              />
                            ) : (
                              <Componente_lk_108_107
                                children={`Ningún equipo depende de acá.`}
                              />
                            ),
                          ]}
                        />,
                        t && (
                          <button
                            type={`button`}
                            onClick={() => D((e) => !e)}
                            className={`${HO} w-fit self-end`}
                            children={[
                              <Ii className={`mr-1 inline h-3.5 w-3.5`} />,
                              E ? `Listo` : `Administrar`,
                            ]}
                          />
                        ),
                      ]}
                    />
                  ),
                  w === `reuniones` && !l && (
                    <div
                      className={`animar-entrada`}
                      children={
                        <Componente_ZO_90_79
                          unidadId={e}
                          unidadNombre={r.nombre}
                          proyectos={s?.proyectos ?? []}
                        />
                      }
                    />
                  ),
                ]}
              />
            ) : (
              <div
                className={`animar-entrada rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                children={[
                  (0, JSXRuntime.jsx)(oi, {
                    className: `mx-auto h-8 w-8 text-(--text)`,
                  }),
                  <p
                    className={`mt-2 text-sm text-(--text)`}
                    children={`No encontramos esa área.`}
                  />,
                  <Sn
                    to={`/organizacion`}
                    className={`mt-3 inline-block text-sm font-medium text-(--accent) hover:underline`}
                    children={`Volver a Organización`}
                  />,
                ]}
              />
            ),
          ]}
        />,
        b && (
          <FormularioUnidad
            datos={b}
            onClose={() => x(null)}
            onGuardado={() => {
              (x(null), O());
            }}
          />
        ),
        S && r && (
          <NuevoProyecto
            grupos={f}
            areas={m}
            unidadFija={r}
            onClose={() => C(!1)}
            onCreado={O}
          />
        ),
      ]}
    />
  );
}
